<template>
  <div>
    <Header></Header>
    <div class='banner-buster'><img src='../assets/img/blockbuster/banner.jpg' alt=''></div>
    <div class='content'>
      <div class='service'>
        <div class='title'><span>鲨鱼公园每5天登陆1座城市</span></div>
        <div class='img'><img src='../assets/img/blockbuster/10.jpg' alt=''></div>
      </div>
      <div class='service'>
        <div class='title'><span>全国150多城市独家经营多店发展丰厚回报</span></div>
        <div class='img'><img src='../assets/img/blockbuster/2.jpg' alt=''></div>
      </div>
      <div class='service'>
        <div class='title'><span>丰富多彩的户外营队</span></div>
        <div class='img'><img src='../assets/img/blockbuster/3.jpg' alt=''></div>
      </div>
      <div class='service'>
        <div class='title'><span>混合经营多元收入全国幼儿园合作</span></div>
        <div><img src='../assets/img/blockbuster/4.jpg' alt=''></div>
      </div>
      <div class='service'>
        <div class='title'><span>混合经营多元收入全国校园合作</span></div>
        <div class='school'>
          <div class='img'><img src='../assets/img/blockbuster/15.jpg' alt=''></div>
          <div class='img'><img src='../assets/img/blockbuster/16.jpg' alt=''></div>
          <div class='img'><img src='../assets/img/blockbuster/17.jpg' alt=''></div>
        </div>
      </div>
      <div class='service'>
        <div class='title'><span>校长代理加盟感言</span></div>
        <div class='img'><img src='../assets/img/blockbuster/8.jpg' alt=''></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
//
export default {
  name: 'Blockbuster',
  components: {Header, Footer},
  data () {
    return {
      msg: 'Blockbuster'
    }
  }
}
</script>
<style>
  .banner-buster{
    width:100%;
    height:auto;
  }
  .banner-buster img{
    width:100%;
  }
  .content {
    width: 100%;
    height: auto;
    text-align: center;
    margin-top:2em;
  }

  .title {
    margin: 0 auto;
    text-align: center;
  }

  .title span {
    font-size: 2em;
    font-weight: bold;
    letter-spacing: 0.1em;
  }

  .service{
    width:80%;
    margin:0 auto;
    text-align: center;
    margin-bottom: 3em;
  }
  .img{
    margin-top:2em;
  }
  .school{
    margin-top:5em;
  }
</style>
